module.exports = __webpack_public_path__ + "static/media/refresh.49b0f05c.svg";